import React from "react";
import Shipments from "../../../Features/Tables/Shipment";

const AllOrders = () => {
  return (
    <div>
      <Shipments />
    </div>
  );
};

export default AllOrders;
